import type { SchematicDelivery, SchematicDeliveryServers } from '../types/buildSchematicDelivery';

const BASE_URL = 'https://spy.playcdu.co/api/notes/builds';

export class SchematicDeliveryApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',
    cache: 'no-store',
    ...options,
  });
  if (!response.ok) {
    const body: unknown = await response.json().catch(() => null);
    const message = body && typeof body === 'object' && 'error' in body && typeof body.error === 'string'
      ? body.error
      : `Schematic delivery request failed (${response.status}). Please try again.`;
    throw new SchematicDeliveryApiError(message, response.status);
  }
  return response.json();
}

export const buildSchematicDeliveryApi = {
  servers(signal?: AbortSignal): Promise<SchematicDeliveryServers> {
    return request('/schematic-delivery/servers', { signal });
  },
  async history(schematicId: string, signal?: AbortSignal): Promise<SchematicDelivery[]> {
    const result = await request<{ deliveries: SchematicDelivery[] }>(`/schematics/${encodeURIComponent(schematicId)}/deliveries`, { signal });
    return result.deliveries;
  },
  async send(schematicId: string, serverAddress: string, requestId: string): Promise<SchematicDelivery> {
    const result = await request<{ delivery: SchematicDelivery }>(`/schematics/${encodeURIComponent(schematicId)}/deliveries`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ server_address: serverAddress, request_id: requestId }),
    });
    return result.delivery;
  },
};
